// extracted by mini-css-extract-plugin
export default {"active":"Menu_active__O52vq","tabMenu":"Menu_tabMenu__os9DK","event":"Menu_event__agdTv"};